import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Multi Sensor Icon Style 01 - Sensors (Material Symbol)
 * Multi sensors are always shown as "active" (indigo) - they have multiple capabilities
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:sensors
 */
export const Style01_Sensors: React.FC<DeviceIconProps> = ({ 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = 'text-indigo-500';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      sensors
    </span>
  );
};

export default Style01_Sensors;
